/*
 * Hogarmola v6 · carrusel de productos de la portada (sections/hm-carrusel.liquid).
 * La fila se desliza sola con el dedo o el panel táctil; aquí solo se encienden las flechas cuando
 * hay más productos de los que caben, se desactivan en los extremos y avanzan una pantalla de tarjetas.
 */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(root) {
    var track = root.querySelector('[data-hm-car-track]');
    var arrows = root.querySelector('[data-hm-car-arrows]');
    if (!track || !arrows || track.hasAttribute('data-hm-car-ready')) return;
    track.setAttribute('data-hm-car-ready', '');
    var prev = arrows.querySelector('[data-hm-car-prev]');
    var next = arrows.querySelector('[data-hm-car-next]');

    // Avanza tantas tarjetas como caben enteras, menos una para no perder el hilo
    function step() {
      var item = track.querySelector('li');
      var width = item ? item.getBoundingClientRect().width : 200;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 16;
      var perView = Math.max(1, Math.floor(track.clientWidth / (width + gap)) - 1);
      return perView * (width + gap);
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var scrolls = max > 4;
      arrows.hidden = !scrolls;
      root.classList.toggle('hm-car--scrolls', scrolls);
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max - 4;
    }

    function go(dir) {
      track.scrollBy({ left: dir * step(), behavior: reduce.matches ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () {
      go(-1);
    });
    next.addEventListener('click', function () {
      go(1);
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.hm-car'), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // En el editor del tema, al volver a cargar la sección
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

/*
 * Vídeo «cómo funciona» de la ficha (tema v11).
 * Antes lo ponía el tema copiando una plantilla, en silencio, y luego se le activaba el sonido; en iPhone eso
 * podía dejar la imagen congelada mientras sonaban la voz y la barra. Ahora el vídeo se crea aquí, dentro del
 * toque del visitante, y arranca ya con sonido. Si la imagen no se mueve aunque el vídeo avance (o la copia en
 * alta calidad falla), se cambia sola a la copia de Shopify por el mismo punto.
 * Tocar el vídeo lo pausa o lo sigue; el botón de arriba a la derecha lo silencia o le vuelve a dar sonido.
 * Se para solo al deslizar a otra foto, al bajar por la página, al cambiar de pestaña o de app, y al salir.
 */
(function () {
  var SEL = '.product-media-container--video deferred-media';
  var ICON_ON =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 9.5h3.2L12 5.5v13l-4.8-4H4z" fill="currentColor"/><path d="M15.5 8.8a4.5 4.5 0 0 1 0 6.4M18.3 6a8.5 8.5 0 0 1 0 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var ICON_OFF =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 9.5h3.2L12 5.5v13l-4.8-4H4z" fill="currentColor"/><path d="M16 9.5l5 5M21 9.5l-5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var HAS_FRAMES = 'requestVideoFrameCallback' in HTMLVideoElement.prototype;
  var players = [];

  function playerOf(media) {
    for (var i = 0; i < players.length; i++) if (players[i].media === media) return players[i];
    return null;
  }

  // Las direcciones del vídeo salen de la plantilla del tema: primero la copia en alta calidad, luego la de Shopify
  function sourcesOf(media) {
    var tpl = media.querySelector('template');
    var scope = tpl && tpl.content ? tpl.content : media;
    var list = [];
    Array.prototype.forEach.call(scope.querySelectorAll('video source'), function (source) {
      var src = source.getAttribute('src');
      if (src && list.indexOf(src) < 0) list.push(src);
    });
    var label = scope.querySelector('video');
    return { srcs: list, label: label ? label.getAttribute('aria-label') : '' };
  }

  // La imagen ya se mueve: se quita la foto de portada y el triángulo del tema
  function reveal(p) {
    if (p.shown) return;
    p.shown = true;
    var poster = p.media.querySelector('[ref="deferredMediaPlayButton"]');
    if (poster) poster.classList.add('deferred-media__playing');
    p.media.classList.add('hm-shown');
  }

  function watchFrames(p, from) {
    var video = p.video;
    var src = video.src;
    p.frames = 0;
    p.watchFrom = from || 0;
    if (!HAS_FRAMES) return;
    function onFrame() {
      if (p.video !== video || video.src !== src) return;
      p.frames += 1;
      if (p.frames >= 2) reveal(p);
      else video.requestVideoFrameCallback(onFrame);
    }
    video.requestVideoFrameCallback(onFrame);
  }

  // Siguiente copia, por el mismo punto y con el mismo sonido
  function fallback(p) {
    if (p.idx >= p.srcs.length - 1) return false;
    var video = p.video;
    var at = video.currentTime || 0;
    var wasPlaying = !video.paused;
    p.idx += 1;
    video.src = p.srcs[p.idx];
    video.load();
    video.addEventListener(
      'loadedmetadata',
      function () {
        if (at > 0.3) {
          try {
            video.currentTime = at;
          } catch (e) {}
        }
      },
      { once: true }
    );
    watchFrames(p, at);
    if (wasPlaying || p.wanted) play(p);
    return true;
  }

  function paint(p) {
    var button = p.button;
    if (!button) return;
    button.innerHTML = p.video.muted ? ICON_OFF + '<span>Activar sonido</span>' : ICON_ON + '<span>Silenciar</span>';
  }

  function addButton(p) {
    if (p.button) return;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'hm-sound';
    button.addEventListener('click', function (event) {
      event.stopPropagation();
      p.video.muted = !p.video.muted;
      p.userMuted = p.video.muted;
      if (p.video.paused) start(p);
    });
    p.button = button;
    p.media.appendChild(button);
    p.video.addEventListener('volumechange', function () {
      paint(p);
    });
    paint(p);
  }

  function state(p) {
    var media = p.media;
    media.classList.toggle('hm-paused', p.started && p.video.paused);
    media.classList.toggle('hm-waiting', p.started && !p.shown && !p.video.paused);
  }

  function build(media) {
    var info = sourcesOf(media);
    if (!info.srcs.length) return null;
    // Que el tema no vuelva a copiar la plantilla ni deje copias suyas sonando debajo
    media.setAttribute('data-media-loaded', 'true');
    Array.prototype.forEach.call(media.querySelectorAll('video'), function (old) {
      old.pause();
      old.remove();
    });

    var video = document.createElement('video');
    video.className = 'hm-video';
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('preload', 'auto');
    if (info.label) video.setAttribute('aria-label', info.label);
    video.src = info.srcs[0];
    media.insertBefore(video, media.querySelector('.hm-sound, .hm-seek'));

    var icon = document.createElement('span');
    icon.className = 'hm-play';
    icon.setAttribute('aria-hidden', 'true');
    var svg = media.querySelector('.deferred-media__poster-icon.icon-play svg');
    if (svg) icon.appendChild(svg.cloneNode(true));
    media.appendChild(icon);

    var p = { media: media, video: video, srcs: info.srcs, idx: 0, frames: 0, watchFrom: 0, shown: false, started: false, wanted: false, userMuted: false, button: null };
    players.push(p);

    ['play', 'pause', 'playing', 'ended', 'waiting'].forEach(function (type) {
      video.addEventListener(type, function () {
        state(p);
      });
    });
    // Sin la función de fotogramas (navegadores antiguos), basta con que el tiempo avance
    video.addEventListener('timeupdate', function () {
      if (!HAS_FRAMES && video.currentTime > 0.15) reveal(p);
      // El tiempo corre pero no ha salido ni un fotograma: la imagen está congelada
      if (HAS_FRAMES && !p.shown && p.frames < 2 && video.currentTime - p.watchFrom > 1.5) fallback(p);
      state(p);
    });
    video.addEventListener('error', function () {
      if (!fallback(p)) {
        p.wanted = false;
        p.started = false;
        media.classList.remove('hm-started', 'hm-waiting');
      }
    });
    watchFrames(p);
    if (observer) observer.observe(media);
    return p;
  }

  function play(p) {
    var video = p.video;
    var started = video.play();
    if (started && started.catch) {
      started.catch(function (error) {
        // Si el navegador no deja que suene, sigue en silencio y el botón ofrece activarlo
        if (error && error.name === 'NotAllowedError' && !video.muted) {
          video.muted = true;
          video.play().catch(function () {});
        }
      });
    }
  }

  function start(p) {
    players.forEach(function (other) {
      if (other !== p && !other.video.paused) other.video.pause();
    });
    p.started = true;
    p.wanted = true;
    p.media.classList.add('hm-started');
    p.video.muted = p.userMuted;
    play(p);
    addButton(p);
    state(p);
  }

  function stop(p) {
    p.wanted = false;
    if (!p.video.paused) p.video.pause();
  }

  function toggle(media) {
    var p = playerOf(media) || build(media);
    if (!p) return;
    if (!p.started || p.video.paused) start(p);
    else stop(p);
  }

  // Se para al dejar de verse: otra foto del carrusel o bajar por la página
  var observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var p = playerOf(entry.target);
              if (p && entry.intersectionRatio < 0.5) stop(p);
            });
          },
          { threshold: [0, 0.5] }
        )
      : null;

  function stopAll() {
    players.forEach(stop);
  }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stopAll();
  });
  window.addEventListener('pagehide', stopAll);

  // Va antes que el tema: este escucha en la captura del documento, y la de la ventana llega primero.
  // Así el toque es del reproductor y el tema no copia su plantilla ni arranca otro vídeo debajo.
  window.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var media = target.closest(SEL);
      if (!media || target.closest('.hm-sound, .hm-seek')) return;
      event.preventDefault();
      event.stopPropagation();
      toggle(media);
    },
    true
  );
})();

/*
 * Barra de avance del vídeo de la ficha: una línea fina abajo del todo que se rellena según avanza
 * el vídeo. Se puede pulsar o arrastrar (con el dedo o el ratón) para ir hacia atrás o hacia delante.
 * Es un <input type="range">, así que también funciona con el teclado y los lectores de pantalla.
 * Sale en cuanto el vídeo empieza a reproducirse (el tema lo arranca solo, en silencio).
 */
(function () {
  function setup(video) {
    var media = video.closest('.product-media-container--video deferred-media');
    if (!media || media.querySelector('.hm-seek')) return;
    var wrap = document.createElement('div');
    wrap.className = 'hm-seek';
    var range = document.createElement('input');
    range.type = 'range';
    range.min = '0';
    range.max = '1000';
    range.step = '1';
    range.value = '0';
    range.setAttribute('aria-label', 'Avance del vídeo');
    wrap.appendChild(range);
    media.appendChild(wrap);

    // El tema puede cambiar el vídeo de sitio: siempre se usa el último que hay dentro
    function current() {
      var all = media.querySelectorAll('video');
      return all[all.length - 1] || video;
    }
    var dragging = false;
    function paint() {
      var v = current();
      if (!dragging && v.duration) range.value = String(Math.round((v.currentTime / v.duration) * 1000));
      wrap.style.setProperty('--hm-seek', range.value / 10 + '%');
      if (!v.paused) window.requestAnimationFrame(paint);
    }
    function seek() {
      var v = current();
      if (v.duration) v.currentTime = (range.value / 1000) * v.duration;
      wrap.style.setProperty('--hm-seek', range.value / 10 + '%');
    }
    // El carrusel de fotos del tema se queda con el gesto (para deslizar) y la barra nativa no se movería,
    // así que el toque y el arrastre se calculan a mano: la posición del dedo sobre la barra marca el punto.
    function toPointer(event) {
      var box = wrap.getBoundingClientRect();
      var x = Math.min(Math.max(event.clientX - box.left, 0), box.width);
      range.value = String(Math.round((x / box.width) * 1000));
      seek();
    }
    wrap.addEventListener('pointerdown', function (event) {
      event.stopPropagation();
      event.preventDefault();
      dragging = true;
      wrap.classList.add('is-dragging');
      if (wrap.setPointerCapture) wrap.setPointerCapture(event.pointerId);
      toPointer(event);
    });
    wrap.addEventListener('pointermove', function (event) {
      if (dragging) toPointer(event);
    });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (type) {
      wrap.addEventListener(type, function () {
        if (!dragging) return;
        dragging = false;
        wrap.classList.remove('is-dragging');
        paint();
      });
    });
    // Que tocar la barra no cuente como tocar el vídeo (no lo pausa ni abre nada)
    ['click', 'touchstart'].forEach(function (type) {
      wrap.addEventListener(type, function (event) { event.stopPropagation(); }, { passive: true });
    });
    // Con el teclado (flechas) sí funciona la barra nativa
    range.addEventListener('input', seek);
    media.addEventListener('play', paint, true);
    media.addEventListener('seeked', paint, true);
    media.addEventListener('loadedmetadata', paint, true);
    paint();
  }

  // «play» no sube por el documento, pero sí se ve en la fase de captura
  document.addEventListener(
    'play',
    function (event) {
      var v = event.target;
      if (v && v.tagName === 'VIDEO') setup(v);
    },
    true
  );
})();
